import { isTruthy } from 'notable-common';
import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowUpdateFlowConfigConfigSchema = z
    .object({
    practiceId: z.string().optional(),
    entityType: z.string().optional(),
    entityId: z.string().optional(),
})
    .refine((obj) => isTruthy(obj.entityType) === isTruthy(obj.entityId), {
    message: 'entityType and entityId must be specified together (or must both be unspecified)',
    path: ['entityId'],
})
    .refine((obj) => isTruthy(obj.practiceId) || isTruthy(obj.entityId), {
    message: 'At least one of practiceId and/or entityType + entityId must be specified',
    path: ['practiceId'],
});
export const FlowUpdateFlowConfigSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.UpdateFlowConfig),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.UpdateFlowConfigData),
    config: FlowUpdateFlowConfigConfigSchema,
});
//# sourceMappingURL=config.js.map